import { HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Button, Spacer } from 'native-base';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';

interface FooterProps {}

export const Footer: React.FC<FooterProps> = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const isMobile = useBreakpointValue({ base: true, sm: false });

  const handleGoBack = () => {
    navigate('Cockpit');
  };

  return (
    <HStack w="full" alignItems="center" justifyContent="space-between">
      {!isMobile && <Spacer />}
      <HStack
        space={Spacing['inline.xxxs']}
        {...(isMobile && { justifyContent: 'space-between', w: 'full' })}>
        <Button
          onPress={handleGoBack}
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          variant="secondary">
          Voltar ao Cockpit
        </Button>
        <Button
          isDisabled
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          variant={'primary'}>
          Acompanhar
        </Button>
      </HStack>
    </HStack>
  );
};
